import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";

export const module: ModuleOptions = {
  resource: ResourceEnum.ConfigNumber,
  bigIcon: <i className="icon-20-label_conf" />,
  smallIcon: <i className="icon-15-label_conf" />,
};
